import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';


@Component({
    selector: 'app-terms-of-use',
    imports: [
        CommonModule,
        SharedModule
    ],
    templateUrl: './termsofuse.component.html',
    styleUrls: ['./termsofuse.component.css']
})
export class TermsOfUseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
